import React, { useEffect, useContext } from "react";

import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useRef } from "react";

import { Context } from "../../../Context";
import { useLocation } from "react-router-dom";
import "./Best.css";
import { getCurrentData, getResults } from "../../../helpers/getData";
import LibraryBook from "../../LibraryBook/LibraryBook";
import uniqid from "uniqid";
import { motion, AnimatePresence } from "framer-motion";

const Best = ({ in: inProp }) => {
  const { data, setData } = useContext(Context);
  const location = useLocation();
  useEffect(() => {
    getCurrent();
    console.log("LOAD");
  }, []);
  const bookObjs = [];

  const getCurrent = async (num) => {
    try {
      setData({ ...data, loading: true });
      const url = `https://api.nytimes.com/svc/books/v3/lists/overview.json?api-key=${process.env.REACT_APP_BEST_KEY}`;

      // const url = `https://api.nytimes.com/svc/books/v3/lists/hardcover-fiction.json?api-key=${process.env.REACT_APP_BEST_KEY}&pages=1`;

      const response = await getCurrentData(url);

      const results = await getResults(response);
      //  console.log("response", updatedResults);
      setData({ results: [...results], loading: false });
    } catch (err) {
      alert(err);
    }
  };

  return (
    <AnimatePresence initial={true}>
      <motion.ul
        location={location}
        key={location.pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        delay="0.75s"
        className="results-ul"
      >
        {data.results.map((book) => {
          return (
            <>
              {book.heading && <p className="heading">{book.heading}</p>}
              {book.img != "" && (
                <LibraryBook key={uniqid()} book={book}></LibraryBook>
              )}
            </>
          );
        })}
      </motion.ul>
      );
    </AnimatePresence>
  );
};

export default Best;
